import { BlurEvent, ClickEvent, DataSourceExecutionEvent, LookupModelSearchEvent, Panel, TableRowExpansionEvent } from "@mcleod/components";
import { AutogenLayoutRecurringMiscInvoiceList } from "./autogen/AutogenLayoutRecurringMiscInvoiceList";
import { CurrencySettings, LogManager, Model, ModelRow } from "@mcleod/core";
import { AutogenLayoutMiscInvoiceExpand } from "./autogen/AutogenLayoutMiscInvoiceExpand";
import { MiscInvoiceDetailTable } from "./MiscInvoiceDetailTable";
import { ImageTable } from "@mcleod/common";
import { ResetFormButton } from "@mcleod/components/src/page/ResetFormButton";

const log = LogManager.getLogger("lme.ar.RecurringMiscInvoiceList");

export class RecurringMiscInvoiceList extends AutogenLayoutRecurringMiscInvoiceList {
    private segAllocControl: ModelRow = null;

    override onLoad() {
        const currencySettings = CurrencySettings.getSingleton();
        this.textboxCurrencyType.visible = currencySettings.multiCurrencyEnabled();

        Model.searchSingleRecord("lme/settlement/seg-alloc-control", null, { extraFields: "lme/dispatch/seg-alloc-control-single" }).then(response => {
            this.segAllocControl = response;
            this.textboxAllocationCode.visible = !!this.segAllocControl && this.segAllocControl.getBoolean("is_active", false);
        }).catch(error => {
            log.error("Failed to load segment allocation control settings:", error);
            this.segAllocControl = null;
            this.textboxAllocationCode.visible = false;
        });

        this.setResetButtonCallback();

        this.mainDataSource.search();
    }

    setResetButtonCallback() {
        const resetButton = this.searchpanelRecurringMiscInvoices["buttonResetForm"] as ResetFormButton;
        if (resetButton) {
            const resetCallback = resetButton.doAfterReset;
            resetButton.doAfterReset = (event: ClickEvent) => {
                resetCallback?.(event);
                this.panelCheckboxes.enabled = true;
                this.checkboxActive.enabled = true;
                this.checkboxInactive.enabled = true;
            };
        }
    }

    sourceMiscBillBeforeExecution(event: DataSourceExecutionEvent) {
        if (this.textboxArCycleCodeIdSearch.lookupModelData == null) {
            event.filter.ar_cycle_code_id = ">"; // ar_cycle_code_id is not null
        }

        if (this.checkboxActive.checked && !this.checkboxInactive.checked) {
            event.filter.end_date = ">=t|="; // end_date is on or after today, or end_date is null
        } else if (!this.checkboxActive.checked && this.checkboxInactive.checked) {
            event.filter.end_date = "<t"; // end_date is before today
        }
    }

    textboxEndDateOnBlur(event: BlurEvent) {
        if (event.changedWhileFocused) {
            const endDateIsNull = this.mainDataSource.searchRow?.isNull("end_date");
            // Checkbox disabledTooltips were not displaying properly, so disable the panel to show its disabledTooltip instead
            this.panelCheckboxes.enabled = endDateIsNull;
            this.checkboxActive.enabled = this.checkboxInactive.enabled = endDateIsNull;
            this.checkboxActive.checked = endDateIsNull ? this.checkboxActive.checked : false;
            this.checkboxInactive.checked = endDateIsNull ? this.checkboxInactive.checked : false;
        }
    }

    textboxAllocationCodeBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.alloc_type = "Z"; // Miscellaneous Billing allocation type
    }

    tableRecurringMiscInvoicesOnRowExpand(event: TableRowExpansionEvent) {
        this.initializeDetailTab(event);
        this.initializeImagesTab(event);
    }

    initializeDetailTab(event: TableRowExpansionEvent) {
        const tableRow = event.getTableRow();
        const modelRow = tableRow.data as ModelRow;
        const expandPanel = event.expandComponentParent as Panel;
        const layoutMiscInvoiceExpand = expandPanel.findComponentById("layoutMiscInvoiceExpand") as AutogenLayoutMiscInvoiceExpand;
        const layoutMiscInvoiceDetailTable = layoutMiscInvoiceExpand.layoutMiscInvoiceDetail as MiscInvoiceDetailTable;
        layoutMiscInvoiceDetailTable.tableMiscInvoiceDetail.allowEdit = false;
        layoutMiscInvoiceDetailTable.tableMiscInvoiceDetail.allowDelete = false;
        const miscInvoiceId = modelRow.getString("id", null);
        if (miscInvoiceId) {
            layoutMiscInvoiceExpand.mainDataSource.search({ "id": miscInvoiceId })
                .catch(error => {
                    log.error(`Failed to load expanded row data for invoice ${miscInvoiceId}:`, error);
                });
        }

        layoutMiscInvoiceExpand.textboxAllocationCode.visible = !!this.segAllocControl && this.segAllocControl.getBoolean("is_active", false);
    }

    initializeImagesTab(event: TableRowExpansionEvent) {
        const tableRow = event.getTableRow();
        const modelRow = tableRow.data as ModelRow;
        const expandPanel = event.expandComponentParent as Panel;
        const imageTable = expandPanel.findComponentById("layoutImageTable") as ImageTable;
        const id = modelRow?.getString("id", null);
        if (id && imageTable) {
            imageTable.buttonUploadImage.visible = false;
            imageTable.populateForRow("MISC_BILL", id);
        }
    }
}
